<template>
    <div v-if="className == 'sub-tab-wrap'" class="sub-tab-wrap">
        <v-container>
            <template v-for="item in gnbs">
                <ul class="tab tab--underline" :key="item.title" v-if="item.title == sh">
                    <li v-for="child in item.children" :key="child.title" class="tab__li" :class="{ active: tabActive == child.title }">
                        <!-- <a :href="child.path" class="tab__btn"
                            ><span>{{ child.title }}</span></a
                        > -->
                        <a :href="child.path" class="tab__btn"><span v-html="child.html"></span></a>
                    </li>
                </ul>
            </template>
        </v-container>
    </div>
    <ul v-else-if="className == 'gnb'" :class="className">
        <template v-for="item in gnbs">
            <li v-if="!item.children" :class="className + '__li'" :key="item.title">
                <router-link :to="item.path" :class="className + '__link'"
                    ><h2>{{ item.title }}</h2></router-link
                >
            </li>

            <li v-else :class="className + '__li'" :key="item.title">
                <div v-if="isMobile" :class="className + '__link gnb__link--toggle'">
                    <h2>{{ item.title }}</h2>
                </div>
                <router-link v-else :to="item.path" :class="className + '__link gnb__link--toggle'"
                    ><h2>{{ item.title }}</h2></router-link
                >
                <ul :class="className + '__sub'">
                    <li v-for="child in item.children" :key="child.title">
                        <router-link :to="child.path">{{ child.title }}</router-link>
                    </li>
                </ul>
            </li>
        </template>
    </ul>
</template>

<script>
export default {
    props: {
        className: String,
        indexNum: String,
        sh: String,
        tabActive: String,
    },
    data: function() {
        return {
            window: {
                width: 0,
                height: 0,
            },
            gnbs: [
                {
                    title: "Company",
                    path: "/company/history",
                    children: [
                        {
                            title: "History",
                            html: "History",
                            path: "/company/history",
                        },
                        {
                            title: "Vision",
                            html: "Vision",
                            path: "/company/vision",
                        },
                    ],
                },
                {
                    title: "Product",
                    path: "/product/organic",
                    children: [
                        {
                            title: "Organic Line",
                            html: "Organic Line",
                            path: "/product/organic",
                        },
                        {
                            title: "High Function Sports Line",
                            html: "High Function Sports Line",
                            path: "/product/sports",
                        },
                        {
                            title: "Active & Legging Line",
                            html: "Active &<br class='d-none d-md-block'/> Legging Line",
                            path: "/product/active",
                        },
                        {
                            title: "Cotton & Basic Line",
                            html: "Cotton &<br class='d-none d-md-block'/> Basic Line",
                            path: "/product/cotton",
                        },
                        {
                            title: "Fleece & Sherpa Line",
                            html: "Fleece &<br class='d-none d-md-block'/> Sherpa Line",
                            path: "/product/fleece",
                        },
                        {
                            title: "Novelty Line",
                            html: "Novelty Line",
                            path: "/product/novelty",
                        },
                        {
                            title: "Comfortable & Cozy Line",
                            html: "Comfortable &<br class='d-none d-md-block'/> Cozy Line",
                            path: "/product/Comfortable",
                        },
                    ],
                },
                {
                    title: "Facilities",
                    path: "/facilities/China",
                    children: [
                        {
                            title: "Meitex_China",
                            html: "Meitex_China",
                            path: "/facilities/China",
                        },
                        {
                            title: "Meitex_Vietnam",
                            html: "Meitex_Vietnam",
                            path: "/facilities/Vietnam",
                        },
                    ],
                },
                {
                    title: "Mei Story",
                    path: "/story",
                },
                {
                    title: "Contact Us",
                    path: "/contact",
                },
            ],
        };
    },
    computed: {
        isDesktop: function() {
            return this.window.width >= 1200;
        },
        isMobile: function() {
            return this.window.width < 1200;
        },
    },
    created: function() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted: function() {},
    methods: {
        handleResize: function() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },
};
</script>

<style scoped>
.sub-tab-wrap .container {
    padding: 0;
    max-width: var(--container);
}
.sub-tab-wrap .tab__li {
    position: relative;
}
.sub-tab-wrap .tab--underline .tab__li span {
    position: static;
}
.sub-tab-wrap .tab--underline .tab__li span::before {
    width: 100%;
}
.sub-tab-wrap .tab--underline .tab__btn {
    color: #aaa;
}
.sub-tab-wrap .tab--underline .tab__li.active .tab__btn {
    color: var(--v-primary-base);
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .sub-tab-wrap {
        margin-top: -80px;
        background-color: rgba(0, 0, 0, 0.6);
    }
    .sub-tab-wrap .tab__li:not(:first-child)::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        -webkit-transform: translate(0, -50%);
        -ms-transform: translate(0, -50%);
        transform: translate(0, -50%);
        display: block;
        width: 1px;
        height: 20px;
        background-color: rgba(255, 255, 255, 0.3);
    }
}
@media (min-width: 1200px) {
}
</style>
